import script from "./DocumentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentEdit.vue?vue&type=script&setup=true&lang=js"

import "./DocumentEdit.vue?vue&type=style&index=0&id=849adda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-849adda4"]])

export default __exports__